// extracted by mini-css-extract-plugin
export var active = "_91-d";
export var blink = "_91-e";
export var container = "_91-5";
export var controls = "_91-0";
export var controlsRight = "_91-1";
export var fakeCursor = "_91-c";
export var hidden = "_91-b";
export var quillContainerSmall = "_91-7";
export var quillEditor = "_91-6";
export var quillEditorSmall = "_91-8";
export var quillFormatButtons = "_91-a";
export var quillToolbar = "_91-9";
export var removePadding = "_91-2";
export var state = "_91-3";
export var stateTitle = "_91-4";